import { render, staticRenderFns } from "./storeHistoryChatPdfComponent.vue?vue&type=template&id=55639729&scoped=true&"
import script from "./storeHistoryChatPdfComponent.vue?vue&type=script&lang=ts&"
export * from "./storeHistoryChatPdfComponent.vue?vue&type=script&lang=ts&"
import style0 from "./storeHistoryChatPdfComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./storeHistoryChatPdfComponent.vue?vue&type=style&index=1&id=55639729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55639729",
  null
  
)

export default component.exports